<app-header></app-header>
<app-resume-step></app-resume-step>
<div class="container mx-auto px-4 mb-6">
  <app-info-top></app-info-top>
  <app-question [question]="questionFloor" [local]="true"></app-question>

  <ng-container *ngIf="roommatesForm">
    <div class="number-roommates">
      <div
        class="grid gap-x-4 space-y-4 mb-4"
        *ngIf="ready && roommatesForm"
        [formGroup]="roommatesForm">
        <div class="custom-inputnumber w-full">
          <p-inputNumber
            [showButtons]="true"
            [formControl]="roommatesForm.controls.numberOfRoommates"
            [step]="1"
            [min]="0"
            [max]="max"
            buttonLayout="horizontal"
            decrementButtonClass="custom-decrement"
            incrementButtonClass="custom-increment"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            class="custom-p-inputnumber w-full" />
          <div class="flex flex-col">
            <small
              class="p-error"
              *ngIf="
                roommatesForm.controls.numberOfRoommates?.invalid &&
                (roommatesForm.controls.numberOfRoommates?.errors)!['required']
              "
              >{{ resource.error.insurer }}</small
            >
          </div>
        </div>
      </div>
      <div class="flex my-5">
        <button
          pButton
          type="button"
          class="button-NS hover:button-NS focus:button-NS active:button-NS w-full"
          [label]="resource.nextstep.keepGoing"
          icon="pi pi-arrow-right"
          iconPos="right"
          (click)="nextStep()"></button>
      </div>
      <app-info-bottom [popUpInfo]="popupInfoFloor"></app-info-bottom>
    </div>
  </ng-container>
</div>

<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-web-callback></app-web-callback>

<app-web-callback-popup
  (cancel)="cancel()"
  (validate)="nextStep()"
  [show]="displayModal"></app-web-callback-popup>
